export default __webpack_public_path__ + "static/media/intersect.0e60581b.svg";